import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { cssTheme } from '@vio/atlas/themes';
import { last, pathOr, pluck } from 'ramda';
const _exp = /*#__PURE__*/() => Flex.Row;
const _exp2 = /*#__PURE__*/() => ({
  height
}) => height;
const HistogramElement = /*#__PURE__*/styled(_exp())({
  name: "HistogramElement",
  class: "h2b1rgz",
  propsAsIs: true,
  vars: {
    "h2b1rgz-0": [_exp2()]
  }
});
const _exp6 = /*#__PURE__*/() => ({
  active
}) => active ? cssTheme.colors.background.interactive.c400 : cssTheme.colors.background.neutral.c100;
const HistogramItemElement = /*#__PURE__*/styled('div')({
  name: "HistogramItemElement",
  class: "h5amaa9",
  propsAsIs: false,
  vars: {
    "h5amaa9-0": [_exp6()]
  }
});
interface HistogramPropsType {
  /** Histogram height */
  height?: string;

  /** Histogram item size */
  step: number;

  /** Histogram active value */
  value: Array<number | null | undefined>;

  /** Histogram values */
  values: Array<{
    id: string;
    value: number;
  }>;
}
const isActive = (bkt: number, min: number, max: number): boolean => {
  return bkt >= min && bkt <= max;
};
const calculateItemHeight = (value: number, maxValue: number): number => {
  return value / maxValue * 100;
};
const DEFAULT_HISTOGRAM_HEIGHT = '38px';
export const Histogram: React.FC<HistogramPropsType> = ({
  values = [],
  value = [],
  step = 1,
  height = DEFAULT_HISTOGRAM_HEIGHT
}) => {
  const [isRendered, setIsRendered] = React.useState<boolean>(false);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsRendered(true);
      clearTimeout(timer);
    }, 10);
    return () => clearTimeout(timer);
  }, []);
  const [min = pathOr(0, [0, 'id'], values), max = pathOr(step, ['id'], last(values)) * step] = value;
  const maxValue = Math.max(...pluck('value', values));
  const minActiveBkt = Math.round(min / step);
  const maxActiveBkt = Math.round(max / step);
  return <HistogramElement alignItems="flex-end" height={height}>
      {values.map(item => {
      const itemHeight = isRendered ? calculateItemHeight(item.value, maxValue) : 0;
      return <HistogramItemElement key={item.id} active={isActive(Number(item.id), minActiveBkt, maxActiveBkt)} style={{
        height: `${itemHeight}%`
      }} />;
    })}
    </HistogramElement>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");